// these are the discount codes mapped to percents that we later pass to shopify
export const VARIANT_CODES = {
  VARIANT_1: {
    40: 'V1_40_GROUP', // 40%
    50: 'V1_50_GROUP', // 50%
  },
  VARIANT_2: {
    30: 'V2_30_GROUP', // 30%
    40: 'V2_40_GROUP', // 40%
  },
  VARIANT_3: {
    20: 'V3_20_GROUP', // 20% off
    30: 'V3_30_GROUP', // 30% off
  },
}

export const calculateDiscountPercentage = (discountRate: number): number => {
  return Math.round((1 - discountRate) * 100)
}

export const getDiscountCodeForVariant = (
  quantity: number,
  variant: keyof typeof VARIANT_CODES = 'VARIANT_1',
  discountPercentage: number,
): string => {
  // Get the codes map for this variant
  const variantCodes = VARIANT_CODES[variant]

  // Check if this quantity has a specific code in this variant
  if (variantCodes && variantCodes[discountPercentage as keyof typeof variantCodes]) {
    return variantCodes[discountPercentage as keyof typeof variantCodes]
  }

  return 'GROUPTICKETSDISCOUNT'
}

export const getVariantKey = (variantNumber: number): keyof typeof VARIANT_CODES => {
  switch (variantNumber) {
    case 1:
      return 'VARIANT_1'
    case 2:
      return 'VARIANT_2'
    case 3:
      return 'VARIANT_3'
    default:
      return 'VARIANT_1'
  }
}

export const getDiscountCode = (quantity: number, variantNumber: number, discountRate: number): string => {
  const discountPercentage = calculateDiscountPercentage(discountRate)
  const variantKey = getVariantKey(variantNumber)
  return getDiscountCodeForVariant(quantity, variantKey, discountPercentage)
}

export const getRodeoDiscountCode = (quantity: number): string => {
  if (quantity === 4) {
    return 'GROUPTICKETSDISCOUNTRODEO4'
  } else if (quantity === 6) {
    return 'GROUPTICKETSDISCOUNTRODEO6'
  } else if (quantity === 10) {
    return 'GROUPTICKETSDISCOUNTRODEO10'
  }

  return 'GROUPTICKETSDISCOUNT'
}
